"use client";
import axios from "axios";
import { createContext, useEffect, useState } from "react";
export const GlobalContext = createContext(null);

export default function GlobalState({ children }) {
  const [userData, setUserData] = useState(null);
  const [connected, setConnected] = useState(null);
  const [refreshProducts, setRefreshProducts] = useState(false);


  const logout = () => {
    localStorage.removeItem("admin");
    localStorage.removeItem("connected");
    setUserData(null);
    setConnected(null);
    router.push("/");
  };
  
  useEffect(() => {
    const savedUserData = JSON.parse(localStorage.getItem("admin"));
    const savedConnect = localStorage.getItem("connected");
    setUserData(savedUserData ? savedUserData : null);
    setConnected(savedConnect ? savedConnect : null);


      const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor); 
    };


  }, []);


  
  return (
    <GlobalContext.Provider
      value={{
        userData,
        setUserData,
        connected,
        setConnected,
        refreshProducts,
        setRefreshProducts,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}
